import { Component, Input } from '@angular/core';
import { IconSize, IconType } from '../../core-data-model';
import { StaticIconCustomizations } from './icon-customizations.model';

enum RenderType {
    ClassSelector,
    DirectAsset,
    SpriteSheet
}

/**
 * !!!!!!!! ALERT !!!!!!!!!!!
 *
 *
 * ****  All the new SVG icons should be added to pi-client-icons, the plan is to phase out Abstract icons eventually
 *
 *
 * !!!!!!!! ALERT !!!!!!!!!!!
 */
@Component({
    selector: 'abstract-icon',
    template: `
        @switch (iconType) {
            <!--
  These components just render inline svg and are great for inclusion of the sprite asap, but should be renamed
  Start
  -->
            @case (IconType.Sliders) {
                <sliders-icon [iconSize]="iconSize"></sliders-icon>
            }
            @case (IconType.BAReport) {
                <ba-report-icon [iconSize]="iconSize"></ba-report-icon>
            }
            @case (IconType.Placard) {
                <placard-icon [iconSize]="iconSize"></placard-icon>
            }
            @case (IconType.LineGraph) {
                <line-graph-icon [iconSize]="iconSize"></line-graph-icon>
            }
            @case (IconType.Clipboard) {
                <clipboard-icon [iconSize]="iconSize"></clipboard-icon>
            }
            @case (IconType.PieChart) {
                <pie-chart-icon [iconSize]="iconSize"></pie-chart-icon>
            }
            @case (IconType.BarGraph) {
                <bar-graph-icon [iconSize]="iconSize"></bar-graph-icon>
            }
            @case (IconType.RutherfordAtom) {
                <rutherford-atom-icon
                    [iconSize]="iconSize"
                ></rutherford-atom-icon>
            }
            @case (IconType.SpeechBubble) {
                <speech-bubble-icon [iconSize]="iconSize"></speech-bubble-icon>
            }
            @case (IconType.NumberedList) {
                <numbered-list-icon [iconSize]="iconSize"></numbered-list-icon>
            }
            @case (IconType.Tactics) {
                <tactics-icon [iconSize]="iconSize"></tactics-icon>
            }
            <!-- End Custom Icon components -->
            <!-- Handle undefined iconType-->
            @case (undefined) {
                <div></div>
            }
            <!-- End Handle undefined iconType-->
            <!-- Generic Icon Component Rendering -->
            @default {
                @switch (getIconRenderType()) {
                    <!-- SVG Icons on the Sprite Sheet -->
                    @case (RenderType.SpriteSheet) {
                        <svg
                            [ngClass]="getCustomCss()"
                            [attr.height]="iconSize"
                            [attr.width]="iconSize"
                            [attr.stroke]="getStroke()"
                            [ngStyle]="getStyle()"
                        >
                            <use [attr.xlink:href]="iconType"></use>
                        </svg>
                    }
                    <!-- End Sprite Sheet Rendering -->
                    <!-- Old moon-ico or fa icons -->
                    @case (RenderType.ClassSelector) {
                        <i
                            class="{{ iconType }}"
                            [ngStyle]="{ 'font-size.px': iconSize }"
                        ></i>
                    }
                    <!-- end class icons -->
                    <!-- img rendered icons -->
                    @case (RenderType.DirectAsset) {
                        <img
                            [ngStyle]="{ 'width.px': iconSize }"
                            [src]="iconType"
                        />
                    }
                    <!-- end img rendered icons -->
                }
            }
        }
    `,
    standalone: false
})
export class AbstractIconComponent {
    /**
     * This input determines what Icon will be rendered.  IconType is left for backwards compatibility and
     * code completion, however a string can be passed in which will be used for rendering the icon.  This string
     * optional type is what will allow other frontend applications to pass in icon references without updating client core.
     */
    @Input()
    iconType: IconType | string;

    @Input()
    iconSize: IconSize;

    @Input()
    customClass: string;

    IconType = IconType;
    RenderType = RenderType;

    getIconRenderType(): RenderType {
        if (this.iconType.includes('/')) {
            return RenderType.DirectAsset;
        }
        if (this.iconType.includes('#')) {
            return RenderType.SpriteSheet;
        }
        return RenderType.ClassSelector;
    }

    getExistingClass(): string {
        return StaticIconCustomizations.get(this.iconType)?.classSelector ?? '';
    }

    getCustomCss(): string {
        return `${this.customClass ?? ''} ${this.getExistingClass()}`;
    }

    getStroke(): string {
        return StaticIconCustomizations.get(this.iconType)?.stroke ?? '';
    }

    getStyle(): any {
        const customizations = StaticIconCustomizations.get(this.iconType);
        const style = customizations?.style ?? {};
        if (customizations?.useFontSize) {
            style['font-size.px'] = this.iconSize;
        }
        return style;
    }
}
